import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Table, TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn,
  Card, CardHeader, CardText, CircularProgress, RaisedButton, Paper, Dialog, FlatButton,
} from "material-ui";
import { GetPrestacionesExcel, ProcesarSolicitudMasiva, ObtenerSolicitudes, LoadingFile, DescargExcelGlosas } from "../FiltroBusqueda/actions";
import styles from "../../styles/styles";
import TablePaginationCustom from "../../TablePagination/view";
import mainState from "../../Main/state";

class GrillaBusquedaSE extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalEnvioExitoso: false,
      modalEnvioError: false,
    };
  }
  componentWillMount() { }

  ExportarExcel = () => {
    this.props.dispatch(LoadingFile(true));
    this.props.dispatch(GetPrestacionesExcel());
  }

  DescargExcelGlosas = () => {
    this.props.dispatch(DescargExcelGlosas());
  }

  UploadSolicitud = (file) => {
    if (file) {
      this.props.dispatch(ProcesarSolicitudMasiva(
        file,
        () => {
          this.setState({ modalEnvioExitoso: true });
          //this.props.dispatch(ObtenerSolicitudes());
          this.txt_file_solicitudespecial.value = "";
        },
        () => { this.setState({ modalEnvioError: true }); }
      ));
    }
  }

  CheckFilterLoaded = () => {
    const loadingInput = mainState.isLoading;

    if (loadingInput === 4) return true;

    return false;
  }

  render() {
    const menuListprestaciones = [];
    if (this.props.prestaciones) {
      this.props.prestaciones.map((row, index) => (
        menuListprestaciones.push((
          <TableRow key={index}>
            <TableRowColumn style={styles.datoTablaBusqueda1}>{row.COD_PRESTADOR}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaBusqueda2} title={row.GLOSA_CODPRESTADOR}>{row.GLOSA_CODPRESTADOR}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaBusqueda3}>{row.COD_ISAPRE}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaBusqueda4}>{row.PROF_CCOD}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaBusqueda5}>{row.UNIDAD === "PE" ? "$" : ""} {row.VALOR}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaBusqueda7}>{row.UNIDAD === "VE" ? "VF" : row.UNIDAD}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaBusqueda6}>{row.TIPO_ATENCION}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaBusqueda8}>{(new Date(row.INICIO_VIG)).toLocaleDateString("en-GB", { timeZone: "UTC" })}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaBusqueda9}>{row.CENTRO_AT}</TableRowColumn>
          </TableRow>
        ))
      ));
    }

    return (
      <div>
        <div style={{ padding: "5px" }}>
          <Card
            initiallyExpanded
            zDepth={0}
          >
            <CardHeader
              actAsExpander
              showExpandableButton
              iconStyle={{ height: 20, width: 20, color: "#212121" }}
              style={{
                paddingTop: "0px", paddingBottom: "0px", maxWidth: "1290px", overflow: "auto",
              }}
            >
              <div style={styles.h1}>Resultado Búsqueda</div>
            </CardHeader>
            <CardText
              expandable
              style={{
                paddingTop: "0px", paddingBottom: "0px", maxWidth: "990px", overflow: "auto",
              }}
            >
              <div>
                <br></br>
                <Paper zDepth={2} >
                  <br></br>
                  <div className="row justify-content-md-center">
                    <div className="col-4">
                      {
                        !this.props.loadingFile ?
                          <RaisedButton
                            onClick={this.ExportarExcel}
                            label="(1) Descargar Resultado"
                            secondary
                            labelStyle={{ fontSize: "11px" }}
                            overlayStyle={{ borderRadius: 5 }}
                            rippleStyle={{ borderRadius: 5 }}
                            style={{ width: "250px", borderRadius: 5, marginLeft: 20 }}
                            buttonStyle={{ borderRadius: 5 }}
                            disabled={false}
                          // disabled={this.WaitTest}
                          />
                          :
                          <CircularProgress />
                      }
                    </div>
                    <div className="col-4">
                      <RaisedButton
                        // onClick={this.ExportarExcel}
                        containerElement="label"
                        label="(2) Cargar Solicitud"
                        secondary
                        labelStyle={{ fontSize: "11px" }}
                        overlayStyle={{ borderRadius: 5 }}
                        rippleStyle={{ borderRadius: 5 }}
                        style={{ width: "200px", borderRadius: 5, marginLeft: 20 }}
                        buttonStyle={{ borderRadius: 5 }}
                      >
                        <input
                          type="file"
                          key="txt_file_solicitudespecial"
                          name="txt_file_solicitudespecial"
                          ref={(c) => { this.txt_file_solicitudespecial = c; }}
                          style={{ display: "none" }}
                          onChange={(e) => this.UploadSolicitud(e.target.files[0])}
                          accept=".xlsx"
                        />
                      </RaisedButton>
                    </div>
                    {/* <div className="col-3">
                      <RaisedButton
                        onClick={this.DescargExcelGlosas}
                        label="(3) Descargar Glosas"
                        secondary
                        labelStyle={{ fontSize: "11px" }}
                        overlayStyle={{ borderRadius: 5 }}
                        rippleStyle={{ borderRadius: 5 }}
                        style={{ width: "200px", borderRadius: 5, marginLeft: 20 }}
                        buttonStyle={{ borderRadius: 5 }}
                      />
                    </div> */}
                  </div>
                  <br></br>
                </Paper>
                <br></br>
              </div>
            </CardText>
          </Card>
        </div>

        <Dialog
          key="dialogSolEspecialEnProceso"
          id="dialogSolEspecialEnProceso"
          actions={[
            // <FlatButton label="Aceptar" onClick={() => this.setState({ modalEnvioExitoso: false })}>
            // </FlatButton>]}
            <FlatButton label="Aceptar" onClick={() => { this.setState({ modalEnvioExitoso: false }); this.ObtenerSolicitudes(); }}>
            </FlatButton>]}
          modal
          open={this.state.modalEnvioExitoso}
          style={{ fontSize: "13px" }}
        >
          Se está validando el archivo enviado, esto puede tardar unos minutos.
          <br></br>
          Podrá ver el resultado de la validación en Archivos Enviados.
        </Dialog>


        <Dialog
          key="dialogSolEspecialEnProcesoError"
          id="dialogSolEspecialEnProcesoError"
          actions={[
            <FlatButton label="Aceptar" onClick={() => this.setState({ modalEnvioError: false })}>
            </FlatButton>]}
          modal
          open={this.state.modalEnvioError}
          style={{ fontSize: "13px" }}
        >
          Hubo un error al enviar la solicitud. Favor intentar nuevamente.
        </Dialog>

      </div>
    );
  }
}

GrillaBusquedaSE.defaultProps = {
};

GrillaBusquedaSE.propTypes = {
  prestaciones: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  loadingFile: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  prestaciones: state.filtroBusquedaSE.prestaciones,
  loading: state.filtroBusquedaSE.loading,
  loadingFile: state.filtroBusquedaSE.loadingFile,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(GrillaBusquedaSE);



// WEBPACK FOOTER //
// ./src/components/SolicitudesEspeciales/GrillaBusqueda/view.jsx